module.exports = __webpack_public_path__ + "static/media/G2.9a60c291.png";